import { TYPES } from '../actions/privacyPolicy'

const initialState = {
	activePrivacy: false,
  activeImpressum: false,
  activeCookies: false,
	activeFaq: false,
	activeContactUs: false,
	activeError: true
}

export const privacyPolicy = (state = initialState, action) => {
	switch(action.type) {

		case TYPES.PRIVACY:
			return { ...state,  activePrivacy: !state.activePrivacy }

		case TYPES.IMPRESSIUM:
			return { ...state,  activeImpressum: !state.activeImpressum }

		case TYPES.COOKIES_TERMS:
			return { ...state,  activeCookies: !state.activeCookies }

		case TYPES.FAQ:
      return { ...state,  activeFaq: !state.activeFaq }

    case TYPES.CONTACT_US:
      return { ...state,  activeContactUs: !state.activeContactUs }

		case TYPES.ERROR:
			return { ...state,  activeError: !state.activeError }

		default: 
		return state
	} 
}


// WEBPACK FOOTER //
// ./src/reducers/privacyPolicy.js